export const TOUR_STEPS = [
  {
    step: 1,
    path: "/",
    title: "Dashboard",
    body: "This is your real-time pipeline. 487 MQLs. 17.3% converting — vs. 2% industry average.",
  },
  {
    step: 2,
    path: "/lead-intake",
    title: "Lead Intake & Scoring",
    body: "Every lead is scored and routed automatically. No manual triage.",
  },
  {
    step: 3,
    path: "/sequence-builder",
    title: "Nurture Sequence Builder",
    body: "Configure once. Every touchpoint executes automatically.",
  },
  {
    step: 4,
    path: "/voice-agent",
    title: "Voice Follow-Up Agent",
    body: "Always-on voice calls — 24/7, no rep time.",
  },
  {
    step: 5,
    path: "/email-sms",
    title: "Email & SMS Automation",
    body: "98% SMS open rate. The most underused channel in medical device sales.",
  },
  {
    step: 6,
    path: "/pipeline",
    title: "Conversion Pipeline",
    body: "Every MQL tracked from entry to demo booked. Acquisition cost recovered.",
  },
  {
    step: 7,
    path: "/orchestration",
    title: "Agent Orchestration",
    body: "Five agents, zero human involvement until the demo is booked.",
  },
  {
    step: 8,
    path: "/growth-intel",
    title: "Growth Intel",
    body: "What the system has learned, and what to build next.",
  },
  {
    step: 9,
    path: "/velocity-engine",
    title: "Conversion Velocity Engine",
    body: "Which of your 487 leads is 4 hours from a yes — right now.",
    finale: true,
  },
];
